// extracted by css-extract-rspack-plugin
export default {"default":"DescriptionItem-module__default__XsUZU","compact":"DescriptionItem-module__compact__iVqWJ"};